import { writePackageCartToCache } from "@/Apollo/hooks/package-cart/packageCartCache";
import { useDisplayCurrencyMutation } from "@/Apollo/hooks/useDisplayCurrencyMutation";
import mutationGQL from "@/Apollo/mutation/package-cart/addListingFeeToPackageCart.graphql";
import {
  AddListingFeeToPackageCartMutation,
  AddListingFeeToPackageCartMutationVariables,
} from "@/Apollo/schema";
import { MutationHookOptions } from "@apollo/client";

export const useAddListingFeeToPackageCart = (
  options?: MutationHookOptions<
    AddListingFeeToPackageCartMutation,
    AddListingFeeToPackageCartMutationVariables
  >
) => {
  return useDisplayCurrencyMutation(mutationGQL, {
    ...options,
    update(cache, result, updateOptions) {
      writePackageCartToCache(
        cache,
        result.data?.addListingFeeToPackageCart,
        updateOptions.variables?.displayCurrency ?? undefined
      );
      options?.update?.(cache, result, updateOptions);
    },
  });
};
